import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Removes selections that are absent from successfully loaded options
 */
export const pruneInvalidSelections = store.effects.create(
  (feature: Plugin['feature']) =>
    feature.actions.load.success.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        selectionLookup: feature.selectors.selectionLookup.asObservable,
      })),
      rxjs.map(
        ({
          action: {
            data: {
              request: {
                criteria: { entityId },
              },
              response: options,
            },
          },
          selectionLookup,
        }) => {
          const selectedIds = selectionLookup[entityId] ?? []
          const optionIds = new Set(options.map(option => option.id))
          const validSelectedIds = selectedIds.filter(id => optionIds.has(id))

          if (validSelectedIds.length === selectedIds.length) {
            return store.effects.SKIP
          }

          return feature.actions.setSelection
            .from('DimensionFilter.OptionsLoaded.PruneSelection')
            .create({
              entityId,
              recordIds: validSelectedIds,
            })
        },
      ),
    ),
)
